module.exports = __webpack_public_path__ + "static/media/Ra.b97821dd.png";